import { takeLatest, call, put, select } from "redux-saga/effects";
import log from "loglevel"

import axios from "../../utils/axios";
import getEnvParam from "../../utils/getEnvParam";

const getOrdersFromApi = (idCd, idCalendarioComercial, token, fornecedorId) => {
	return new Promise((resolve, reject) => {
		return axios.request({
			method: "POST",
			headers: {
				"Content-Type": "application/graphql",
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
				"Authorization": token
			},
			data: 
			`query {
				buscarPedidosPorFornecedorCdSemana(idFornecedor: ${fornecedorId}, idCd: ${idCd}, idCalendarioComercial: ${idCalendarioComercial}) {
					id
					qtCompra
					qtVolumes
					dtEmissao
					naturezaPedido
					status
				}
			}`
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

//generators
function* getOrdersModal(payload) {

	try {
		const { token } = yield select(state => state.authentication)
		
		const data = yield call(getOrdersFromApi, payload.idCd, payload.idCalendarioComercial, token, payload.fornecedorId);

		if (data.buscarPedidosPorFornecedorCdSemana) {
			yield put({
				type: "ORDERS_MODAL", payload: data.buscarPedidosPorFornecedorCdSemana
			});
		}

	} catch (error) {
		//Este bloco em producao deverah ser melhor tratado e
		//apresentar uma mensagem para o cliente
		log.info(error);
	}

}

// //Generator function
export function* getLoadOrdersWatcher() {
	yield takeLatest("GET_ORDERS_MODAL", getOrdersModal);
}
